module.exports = __webpack_public_path__ + "static/media/40-active.692daec5.png";